import React, { useContext, useState, useEffect } from 'react'

import CustomTable from '../../components/molecules/CustomTable'
import CustomSearch from '../../components/molecules/CustomSearch'
import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import move from 'lodash-move'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import Loaders from '../../components/molecules/Loaders'
import SettingContext from '../../context/setting/settingContext'
import DynamicContext from '../../context/dynamic/dynamicContext'

// import DropdownManage from './dropdown'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const FieldValueManage = (props) => {
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const dynamiccontext = useContext(DynamicContext)
    const {
        single_property,
        getSingleProperty,
        propertyTableAction,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext

    const toggleFullScreenPopup = props.function
    const [data, setData] = useState({
        status: 'new',
        popup: false,
        id: 0,
    })

    const [reload, setReload] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const validationArray = Yup.object({
        view_page: Yup.number().required('Required!'),
        label: Yup.string()
            .max(50, 'This field has to be exactly 50 characters!')
            .required('Required'),
        type: Yup.string().required('Required'),
        sortfield_name: Yup.string()
            .nullable()
            .when('diff_sort', {
                is: (type) => type === 1,
                then: Yup.string().required('Required!'),
            }),
        variable_name: Yup.string()
            .nullable()
            .when('diff_name', {
                is: (type) => type === 1,
                then: Yup.string().required('Required!'),
            }),
    })
    console.log(props.viewPage, 'viewppp')

    const formik = useFormik({
        initialValues: {
            id: 0,
            view_page: props.viewPage,
            label: '',
            field: '',
            type: '',
            sort: 0,
            sort_field: '',
            folder: '',
            table_search: 0,
            diff_name: 0,
            variable_name: '',
            is_deletable: 1,
            is_default: 0,
            diff_sort: 0,
            show_order: 0,
            sortfield_name: '',
            filter_type: '',
            class: '',
            active: 1,
            filterable: 0,
            editable: 0,
            filterField: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values
            if (!value.diff_name) {
                console.log('coming here')
                value.field = value.label
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9 ]/g, '')
                    .replace(/ /g, '_')
            }
            // value.country = 0
            // value.state = 0
            // if (value.type === 'select' || value.type === 'multiselect') {
            //     if (value.selectType === 'country') {
            //         value.country = 1
            //     } else if (value.selectType === 'state') {
            //         value.state = 1
            //     } else if (value.selectType === 'subSelect') {
            //         value.subSelect = 1
            //     }
            // }
            // value.forOrganization = 0
            // value.forBuyer = 0
            // if (value.view_page === 3) {
            //     if (value.userType) {
            //         if (value.userType === 'forOrganization') {
            //             value.forOrganization = 1
            //         } else if (value.userType === 'forBuyer') {
            //             value.forBuyer = 1
            //         } else if (value.userType === 'both') {
            //             value.forBuyer = 1
            //             value.forOrganization = 1
            //         }
            //     }
            // }
            console.log('+++++++++++++', value)
            value.view_page = props.viewPage
            propertyTableAction(value)
            setLoading(true)
        },
    })

    const details = {
        formik: formik,
        data: [
            {
                label: 'Label',
                placeholder: 'Enter a label',
                type: 'text',
                class: `col-sm-6 col-12`,
                name: 'label',
            },
            {
                label: 'Property type',
                placeholder: 'Select property type',
                class: `col-sm-6 col-12`,
                type: 'select',
                disabled: formik.values.is_default ? true : false,
                options: [
                    { show: 'Price', value: 'price' },
                    { show: 'Date', value: 'date' },
                    { show: 'Date Time', value: 'datetime' },
                    { show: 'Image Url', value: 'imagewithurl' },
                    { show: 'Text', value: 'text' },
                    { show: 'Capitalize', value: 'capitalize' },
                    { show: 'Single Select', value: 'singleSelect' },
                    { show: 'Multi Select', value: 'multiselect' },
                    { show: 'Select', value: 'dropdown' },
                    { show: 'Check Box', value: 'dropdown' },
                    { show: 'Radio', value: 'dropdown' },
                    // { show: 'Multi Select', value: 'dropdown' },
                    { show: 'Multi Check Box', value: 'dropdown' },
                ],
                name: 'type',
            },
            {
                label: 'Folder name',
                placeholder: 'Create a folder name',
                type: 'text',
                disabled: formik.values.is_default ? true : false,
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'imagewithurl' ? '' : 'd-none'
                }`,
                name: 'folder',
            },
            {
                label: 'Default',
                placeholder: 'Default',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3`,
                name: 'is_default',
            },

            {
                label: 'Sort',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3`,
                name: 'sort',
            },
            {
                label: 'Different Sort Name',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3 ${
                    formik.values.sort ? '' : 'd-none'
                }`,
                name: 'diff_sort',
            },
            {
                label: 'Table Search',
                placeholder: 'Table Search',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3`,
                name: 'table_search',
            },
            {
                label: 'Choose a different variable name',
                // disabled: formik.values.diffname ? true : false,
                type: 'switch',
                class: `col-sm-4 col-12 mb-3`,
                name: 'diff_name',
            },
            {
                label: 'Filter',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3`,
                name: 'filterable',
            },
            {
                label: 'Edit',
                type: 'switch',
                class: `col-sm-auto col-12 mb-3`,
                name: 'editable',
            },
            {
                label: 'Sort Field Name',
                placeholder: 'Enter a field name',
                type: 'text',
                class: `col-sm-6 col-12 ${
                    formik.values.diff_sort ? '' : 'd-none'
                }`,
                name: 'sortfield_name',
            },
            {
                label: 'Filter Field Name',
                placeholder: 'Enter a field name',
                type: 'text',
                class: `col-sm-6 col-12 ${
                    formik.values.filterable ? '' : 'd-none'
                }`,
                name: 'filterField',
            },
            {
                label: 'Variable name',
                placeholder: `Enter a variable name`,
                type: 'text',
                disabled: formik.values.is_default ? true : false,
                class: `col-sm-6 col-12 ${
                    formik.values.diff_name ? '' : 'd-none'
                }`,
                name: 'variable_name',
            },

            {
                label: 'Search type',
                placeholder: 'Select Search type',
                class: `col-sm-6 col-12 mb-3  ${
                    formik.values.table_search ? '' : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: 'In', value: 'in' },
                    { show: 'Not In', value: 'notin' },
                    { show: 'Greater or Equal', value: 'greaterequal' },
                    { show: 'Image Url', value: 'greater' },
                    { show: 'smallerequal', value: 'smallerequal' },
                    { show: 'Find In Array', value: 'findinarray' },
                    { show: 'Array In', value: 'arrayin' },
                    { show: 'Array', value: 'array' },
                    { show: 'Date Greater', value: 'dategreater' },
                    { show: 'Date Smaller', value: 'datesmaller' },
                    {
                        show: 'Date Greater Or Equal',
                        value: 'dategreaterequal',
                    },
                    {
                        show: 'Date Smaller Or Equal',
                        value: 'datesmallerequal',
                    },
                    { show: 'Smaller', value: 'smaller' },
                    { show: 'Range', value: 'range' },
                    { show: 'Like', value: 'like' },
                    { show: 'Array In Multiple', value: 'arrayinmultiple' },
                ],
                name: 'filter_type',
            },
            {
                label: 'Property size',
                placeholder: 'Select property size',
                class: `col-sm-6 col-12  ${
                    formik.values.table_search ? '' : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: 'Small', value: 'col-sm-3 col-12' },
                    { show: 'Medium', value: 'col-sm-6 col-12' },
                    { show: 'Large', value: 'col-12' },
                ],
                name: 'class',
            },
        ],
    }

    useEffect(() => {
        setData(props.data)
        setValue(0)
    }, [props.data])

    useEffect(() => {
        if (data) {
            console.log('manage inside', data)
            if (data.status === 'edit') {
                formik.values.id = data.data.id
                getSingleProperty({
                    id: formik.values.id,
                    table: 'dynamic_tables',
                })
                setLoading(true)
            } else {
                resetFrom()
            }
        }
    }, [data])

    useEffect(() => {
        if (single_property.record && data.status === 'edit') {
            const template = single_property.record
            formik.setFieldValue('id', template.id)
            formik.setFieldValue('label', template.label)
            formik.setFieldValue('field', template.field)
            formik.setFieldValue('type', template.type)
            formik.setFieldValue('variable_name', template.field)
            formik.setFieldValue('show_order', template.show_order)
            formik.setFieldValue('is_deletable', template.is_deletable)
            formik.setFieldValue('is_default', template.is_default)
            formik.setFieldValue('diff_name', template.diff_name)
            formik.setFieldValue('folder', template.folder)
            formik.setFieldValue('table_search', template.table_search)
            formik.setFieldValue('active', template.active)
            formik.setFieldValue('sort', template.sort)
            formik.setFieldValue('diff_sort', template.diff_sort)

            formik.setFieldValue('filterable', template.filterable)
            formik.setFieldValue('editable', template.editable)
            formik.setFieldValue('filterField', template.filterField)

            if (template.sort_field) {
                let dummyString = template.sort_field.toString()
                let sortValue = dummyString.split('.').pop('')
                formik.setFieldValue('sortfield_name', sortValue)
            }
            formik.setFieldValue('filter_type', template.filter_type)
            formik.setFieldValue('class', template.class)

            // if (formik.values.view_page === 3) {
            //     if (template.forOrganization === 1 && template.forBuyer === 1) {
            //         formik.setFieldValue('userType', 'both')
            //     } else if (template.forOrganization === 1) {
            //         formik.setFieldValue('userType', 'forOrganization')
            //     } else if (template.forBuyer === 1) {
            //         formik.setFieldValue('userType', 'forBuyer')
            //     }
            // }
            setReload(!reload)
        } else {
            console.log('heree 111')
            resetFrom()
        }
        setLoading(false)
    }, [single_property])

    const resetFrom = () => {
        formik.values.id = 0
        formik.setFieldValue('label', '')
        formik.setFieldValue('placeholder', '')
        formik.setFieldValue('variable_name', '')
        formik.setFieldValue('table_search', 0)
        formik.setFieldValue('sort_field', '')
        formik.setFieldValue('sortfield_name', '')
        formik.setFieldValue('sort', 0)
        formik.setFieldValue('type', '')
        formik.setFieldValue('active', 1)
        formik.handleReset()
    }

    const handleClose = () => {
        toggleFullScreenPopup(false, 'new', 0)
        resetFrom()
    }

    useEffect(() => {
        if (formik.values.variable_name && !formik.values.diff_name) {
            console.log('coming here1234')
            formik.values.field = formik.values.variable_name
                .toLowerCase()
                .replace(/[^a-zA-Z0-9 ]/g, '')
                .replace(/ /g, '_')
        } else {
            formik.values.field = formik.values.variable_name
        }
    }, [formik.values.variable_name])

    useEffect(() => {
        if (formik.values.sortfield_name) {
            let dummyString = formik.values.sortfield_name.toString()
            console.log(dummyString, 'dummy')
            console.log(dummyString.split('.').pop(''), 'hiiii')
            if (formik.values.sortfield_name !== formik.values.sort_field) {
                let name = formik.values.sortfield_name
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9_ ]/g, '')
                    .replace(/ /g, '_')
                if (formik.values.isDefault) {
                    if (formik.values.view_page === 1) {
                        formik.values.sort_field = `p.${name}`
                    } else if (formik.values.view_page === 2) {
                        formik.values.sort_field = `ac.${name}`
                    } else if (formik.values.view_page === 3) {
                        formik.values.sort_field = `u.${name}`
                    }
                } else {
                    if (formik.values.view_page === 1) {
                        formik.values.sort_field = `it.${name}`
                    } else if (formik.values.view_page === 2) {
                        formik.values.sort_field = `cac.${name}`
                    } else if (formik.values.view_page === 3) {
                        formik.values.sort_field = `cu.${name}`
                    }
                }
            }
        }
        console.log(formik.values.sort_field, 'sortFields')
    }, [formik.values.sortfield_name])

    useEffect(() => {
        if (responseStatusDynamic) {
            if (responseStatusDynamic.status === 'success') {
                if (responseStatusDynamic.from === 'propertyTableAction') {
                    if (
                        (formik.values.type === 'select' &&
                            formik.values.selectType === 'default') ||
                        formik.values.type === 'checkboxarray' ||
                        (formik.values.type === 'multiselect' &&
                            formik.values.selectType === 'default') ||
                        formik.values.type === 'radio'
                    ) {
                        if (responseStatusDynamic.data.id) {
                            setData({
                                popup: true,
                                status: 'edit',
                                data: {
                                    id: responseStatusDynamic.data.id,
                                },
                            })
                            setValue(1)
                        }
                    } else {
                        toggleFullScreenPopup(false)
                    }
                }
            }
            setLoading(false)
        }
    }, [responseStatusDynamic])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'Add New Property' : 'Edit Property'
            }
            open={data.popup}
            handleClose={() => handleClose()}
        >
            {isLoading ? (
                <div className="fieldsLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    <div className="dynamicFieldsCnt dynamicTableCnt mt-4">
                        <div className="fspBody">
                            {((formik.values.type === 'select' &&
                                formik.values.selectType === 'default') ||
                                formik.values.type === 'checkboxarray' ||
                                (formik.values.type === 'multiselect' &&
                                    formik.values.selectType === 'default') ||
                                formik.values.type === 'radio') &&
                            data.status === 'edit' ? (
                                <>
                                    <AppBar
                                        position="static"
                                        className="tabHeader mb-4"
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="simple tabs example"
                                        >
                                            <Tab
                                                label="Details"
                                                {...a11yProps(0)}
                                            />
                                            <Tab
                                                label="Values"
                                                {...a11yProps(1)}
                                            />
                                        </Tabs>
                                    </AppBar>
                                </>
                            ) : null}

                            <TabPanel value={value} index={0}>
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <div className="row">
                                        {mapData(details)}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center">
                                        {/* {formik.values.isDefault ? null : ( */}
                                        <>
                                            <SecondaryButton
                                                id="field_value_reset"
                                                label="Reset"
                                                type="reset"
                                                onClick={() => resetFrom()}
                                            />
                                            <PrimaryButton
                                                id="field_value_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </>
                                        {/* )} */}
                                    </div>
                                </form>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <>
                                    {(formik.values.type === 'select' ||
                                        formik.values.type ===
                                            'checkboxarray' ||
                                        formik.values.type === 'multiselect' ||
                                        formik.values.type === 'radio') &&
                                    data.status === 'edit' ? (
                                        <>
                                            {/* <DropdownManage name={formik.values.name} /> */}
                                        </>
                                    ) : null}
                                </>
                            </TabPanel>
                        </div>
                    </div>
                </>
            )}
        </FullScreenPopup>
    )
}

export default FieldValueManage
